
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import SiteButton from '~/components/site/Button.vue'
import InlineIcon from '~/components/_general/InlineIcon.vue'

export default Vue.extend({
  name: 'PlayerAudioButton',
  components: { InlineIcon, SiteButton },
  props: {
    defaultText: {
      type: String as PropType<TranslateResult>,
      default(): TranslateResult {
        return this.$t('Play Audio')
      },
    },
    audioStream: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      playing: false,
    }
  },
  computed: {
    audioElement(): HTMLAudioElement | undefined {
      return this.$refs.reading as HTMLAudioElement | undefined
    },
  },
  methods: {
    toggleAudio() {
      if (!this.audioElement) return
      if (this.playing) {
        this.audioElement.pause()
      } else {
        this.audioElement.play()
      }
      this.playing = !this.playing
    },
  },
})
